<article class="message">
    <core-helper-box-header-user-date 
                [date]="message.date" 
                [user]="message.version_share.entry.user" 
                [versionShares]="message.user_version_shares">
            </core-helper-box-header-user-date>
    <ng-container [ngSwitch]="message.type">
        <!-- uploaded -->
        <ng-template [ngSwitchCase]="VERSION_SHARE_MESSAGE_TYPE.UPLOADED_MESSAGE_TYPE">
            <div class="content line">
                <div class="message-text" [innerHTML]="message.message"></div>
            </div>
        </ng-template>
        <!-- approval -->
        <ng-template [ngSwitchCase]="VERSION_SHARE_MESSAGE_TYPE.APPROVAL_MESSAGE_TYPE">
            <div class="approval-box-action">
                <figure *ngIf="message.version_share.status.status_code == VERSION_SHARE_APPROVAL_STATUS.APPROVED_CODE" class="action-icon approve-ico"></figure>
                <figure *ngIf="message.version_share.status.status_code == VERSION_SHARE_APPROVAL_STATUS.REJECTED_CODE" class="action-icon reject-ico"></figure>
                <div class="content">
                    <div class="message-text" [innerHTML]="message.message"></div>
                </div>
            </div>
        </ng-template>
        <!-- TO REVIEW ng17 when no ngSwitchDefault due to strict comparison -->
    </ng-container>
</article>
